import React from 'react';
import injectSheet from 'react-jss';

const EditButton = (props) => {
  const {
    onClick,
    icon = 'edit',
    label,
    classes: c
  } = props;

  return (
    <div
      className={c.controlBtn}
      onClick={onClick}
    >
      <div className="material-icons">{icon}</div>
      <span>{label}</span>
    </div>
  );
};

const styles = {
  controlBtn: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid rgba(247, 247, 247, .75)',
    width: '160px',
    height: '36px',
    borderRadius: '2px',
    marginTop: '5px',
    marginBottom: '5px',
    fontSize: '14px',
    transition: 'all .25s ease',
    '&>.material-icons': {
      fontSize: '18px',
      marginRight: '5px'
    },
    '&:hover': {
      backgroundColor: 'rgba(180, 180, 180, .85)',
      color: 'white'
    }
  }
};

export default injectSheet(styles)(EditButton);
